import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import {
  AUTO_APPROVED,
  LEAVE_STATUS_MAPING,
  LEAVE_TYPE_MAPING,
  MENSTRUAL,
  NAV_HEIGHT,
} from "../../helper/Constant";
import { IMyLeaveResponse, IPayrollConfig } from "../../helper/Interface";
import { formatDate, getDateFromString } from "../../helper/Utils";
import moment from "moment";
import { AiFillCloseCircle } from "react-icons/ai";

interface IProps {
  readonly onLeaveHistoryClose: () => void;
  readonly isLeaveHistoryOpen: boolean;
  readonly leavesData?: IMyLeaveResponse;
  readonly onDateClick?: ({
    date,
    leaveId,
  }: {
    date: Date;
    leaveId?: number;
  }) => void;
  readonly canCancelLeave: boolean;
  readonly empName: string;
  readonly year: number;
  readonly payrollConfig?: IPayrollConfig;
}
function LeaveHistory(props: IProps) {
  const {
    isLeaveHistoryOpen,
    onLeaveHistoryClose,
    leavesData,
    onDateClick,
    canCancelLeave,
    empName,
    year,
    payrollConfig,
  } = props;
  return (
    <Drawer
      placement={"bottom"}
      onClose={onLeaveHistoryClose}
      isOpen={isLeaveHistoryOpen}
      isFullHeight
    >
      <DrawerOverlay />
      <DrawerContent maxH={`calc(100vh - ${NAV_HEIGHT}px)`}>
        <DrawerCloseButton />
        <DrawerHeader borderBottomWidth="1px">
          {`Leaves History | ${empName} | ${year}`}
        </DrawerHeader>
        <DrawerBody p={0}>
          {leavesData?.leaves ? (
            <TableContainer
              background="white"
              width={"full"}
              border={"1px solid #1e2640"}
              borderRadius={"md"}
            >
              <Table variant="simple">
                <Thead height={"48px"}>
                  <Tr>
                    <Th background="#013F5E" color="white">
                      From
                    </Th>
                    <Th background="#013F5E" color="white">
                      To
                    </Th>
                    <Th background="#013F5E" color="white">
                      Duration
                    </Th>
                    <Th background="#013F5E" color="white">
                      Type
                    </Th>
                    <Th background="#013F5E" color="white">
                      Applied On
                    </Th>
                    <Th background="#013F5E" color="white">
                      Comment
                    </Th>
                    <Th background="#013F5E" color="white">
                      Status
                    </Th>
                    {canCancelLeave ? (
                      <Th background="#013F5E" color="white">
                        Action
                      </Th>
                    ) : null}
                  </Tr>
                </Thead>
                <Tbody fontSize={"sm"}>
                  {leavesData.leaves
                    .filter(({ status }) => status === AUTO_APPROVED)
                    .sort(
                      (a, b) =>
                        new Date(a.fromDate).getTime() -
                        new Date(b.fromDate).getTime(),
                    )
                    .map(
                      (
                        {
                          id,
                          appliedOn,
                          comment,
                          fromDate,
                          status,
                          toDate,
                          type,
                        },
                        i,
                      ) => (
                        <Tr key={id}>
                          <Td py={"3"}>{formatDate(fromDate)}</Td>
                          <Td py={"3"}>{formatDate(toDate)}</Td>
                          <Td py={"3"}>
                            {moment(new Date(toDate)).diff(
                              moment(fromDate),
                              "days",
                            ) + 1}
                            {`${
                              moment(new Date(toDate)).diff(
                                moment(fromDate),
                                "days",
                              )
                                ? " days"
                                : " day"
                            }`}
                          </Td>
                          <Td py={"3"}>
                            <Flex
                              background={
                                LEAVE_TYPE_MAPING.find(
                                  ({ value }) => type === value,
                                )?.bgColor ?? "white"
                              }
                              py={"0.5"}
                              px={"2"}
                              width={"fit-content"}
                              rounded={"sm"}
                            >
                              <Text
                                color={
                                  LEAVE_TYPE_MAPING.find(
                                    ({ value }) => type === value,
                                  )?.color ?? "black"
                                }
                                fontWeight={"medium"}
                              >
                                {
                                  LEAVE_TYPE_MAPING.find(
                                    ({ value }) => type === value,
                                  )?.label
                                }
                              </Text>
                            </Flex>
                          </Td>
                          <Td py={"3"}>{formatDate(appliedOn)}</Td>
                          <Td py={"3"}>{comment}</Td>
                          <Td py={"3"}>
                            <Flex>
                              <Text
                                color={
                                  LEAVE_STATUS_MAPING.find(
                                    ({ value }) => status === value,
                                  )?.color ?? "black"
                                }
                                fontWeight={"medium"}
                              >
                                {
                                  LEAVE_STATUS_MAPING.find(
                                    ({ value }) => status === value,
                                  )?.label
                                }
                              </Text>
                            </Flex>
                          </Td>
                          {canCancelLeave ? (
                            <Td py={"3"}>
                              {payrollConfig &&
                              getDateFromString(toDate).getTime() >=
                                moment(
                                  type === MENSTRUAL
                                    ? undefined
                                    : payrollConfig.currentPStartDateTime,
                                )
                                  .startOf("day")
                                  .unix() *
                                  1000 &&
                              onDateClick ? (
                                <Button
                                  leftIcon={<AiFillCloseCircle />}
                                  size={"sm"}
                                  variant={"ghost"}
                                  colorScheme="red"
                                  onClick={() =>
                                    onDateClick({
                                      date: getDateFromString(fromDate),
                                      leaveId: id,
                                    })
                                  }
                                >
                                  Cancel
                                </Button>
                              ) : null}
                            </Td>
                          ) : null}
                        </Tr>
                      ),
                    )}
                </Tbody>
              </Table>
            </TableContainer>
          ) : null}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}

export default LeaveHistory;
